import React from 'react';
import { Link } from 'react-router-dom'
import cross from '../../images/cross.png'
import hero_box1 from '../../images/hero_box1.png'
import hero_box2 from '../../images/hero_box2.png'
import vectornew from '../../images/vectornew.png'



const ServiceHero = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <>
            <section className="business_consulting_hero_section section_decoration" style={{ backgroundImage: `url(${vectornew})` }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="business_consulting_hero_content">
                                <span class="sub_heading">AI SEO</span>
                                <br/>
                                <br/>
                                
                                <h1>{props.top_title}</h1>
                                <p>
                                    {props.top_desp}
                                </p>
                                <Link onClick={ClickHandler} className="creative_btn" to="/pricing">
                                    <span className="btn_label bg-primary">Book Strategy Call</span>
                                </Link>
                            </div>
                        </div>
                    
                    </div>
                </div>
            </section>
        </>
    
    )
}

export default ServiceHero;